var _rect, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 56,
    viewBox: "0 0 182 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Solhint_mockup v11",
    clipPath: "url(#clip0_27_1327)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 5129,
    transform: "translate(-812 -949)",
    fill: "#12141D",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 8742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content section 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 126",
    filter: "url(#filter0_f_27_1327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -205.932,
    cy: 467.848,
    r: 98,
    fill: "#9F36F2"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Brand logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 8748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 8745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    d: "M0 32.0107L17.5028 42.47V55.9995",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4",
    opacity: 0.2,
    d: "M35.0047 32.0107L17.502 42.47V55.9995",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    opacity: 0.3,
    d: "M17.5028 19.2983L0 29.7576L17.5028 40.2169V19.2983Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5028 0.123047V19.2988L0.000390996 29.7579L0 29.7576L17.5028 0.123047Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    opacity: 0.1,
    d: "M17.502 19.2983L35.0047 29.7576L17.502 40.2169V19.2983Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0047 29.7576L17.502 0.123047V19.2988L35.0043 29.7579L35.0047 29.7576Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 7",
    d: "M46.8322 20.7258C46.8086 19.6893 47.0442 18.6606 47.5232 17.7419C47.9629 16.9017 48.6304 16.2028 49.4548 15.7317C50.3264 15.2449 51.3158 15.0014 52.3209 15.025C53.3025 15.0093 54.2683 15.2606 55.1085 15.7553C55.9251 16.2421 56.5926 16.9567 57.0245 17.8047C57.4956 18.7313 57.7312 19.7678 57.7155 20.8121V21.668H49.7375C49.7532 22.2962 50.0359 22.893 50.5071 23.3092C51.0253 23.7489 51.6927 23.9688 52.3759 23.9374C52.8941 23.9374 53.4124 23.8196 53.8757 23.584C54.4411 23.2621 54.9514 22.8459 55.3755 22.359L57.1815 24.2043C56.5769 24.8796 55.8466 25.4293 55.03 25.8141C54.1976 26.2067 53.2868 26.403 52.368 26.3951C51.3551 26.4187 50.35 26.1753 49.4627 25.6884C48.6304 25.2251 47.9551 24.5341 47.5153 23.6861C47.0442 22.7752 46.8086 21.7544 46.8322 20.7258ZM54.7866 19.5479C54.7394 18.9669 54.4568 18.4329 54.0013 18.0638C53.0041 17.2865 51.6064 17.2786 50.6013 18.0403C50.1537 18.425 49.8553 18.959 49.7768 19.5401H54.7866V19.5479Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M66.7844 17.923V22.2496C66.7609 22.5402 66.8473 22.8229 67.0357 23.0427C67.2791 23.2312 67.5775 23.3175 67.8759 23.2861H70.3337V26.0894H67.6168C66.6274 26.1522 65.6459 25.8538 64.8528 25.2492C64.1775 24.6367 63.8241 23.7494 63.8791 22.8464V17.9309H61.2407V15.3318H63.8791V12.5913H66.7844V15.3318H71.0011V17.9309H66.7766L66.7844 17.923Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 9",
    d: "M74.9438 11.2646H77.8492V16.3215H77.8885C79.2469 14.916 81.3906 14.6176 83.0867 15.5913C83.707 15.976 84.1939 16.5335 84.5079 17.1931C84.8613 17.9391 85.034 18.7636 85.0183 19.5881V26.0819H82.113V19.9728C82.1444 19.3604 81.9481 18.7636 81.5633 18.2846C81.1786 17.8684 80.6289 17.6486 80.0635 17.6721C79.4589 17.6407 78.8778 17.8527 78.4381 18.2689C78.0298 18.7165 77.8178 19.3133 77.8492 19.9257V26.0741H74.9438V11.2646Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 10",
    d: "M88.2371 20.7258C88.2136 19.6893 88.457 18.6606 88.9281 17.7419C89.3679 16.9017 90.0353 16.2028 90.8598 15.7317C91.7314 15.2449 92.7208 15.0014 93.718 15.025C94.6996 15.0093 95.6654 15.2606 96.5056 15.7553C97.3223 16.2421 97.9897 16.9567 98.4216 17.8047C98.8927 18.7313 99.1283 19.7678 99.1126 20.8121V21.668H91.1346C91.1503 22.2962 91.433 22.893 91.9042 23.3092C92.4224 23.7489 93.0899 23.9688 93.773 23.9374C94.2913 23.9374 94.8095 23.8196 95.2728 23.584C95.8382 23.2621 96.3486 22.8459 96.7726 22.359L98.5786 24.2043C97.974 24.8796 97.2437 25.4293 96.4271 25.8141C95.5948 26.2067 94.6839 26.403 93.7652 26.3951C92.7522 26.4187 91.7471 26.1753 90.8598 25.6884C90.0275 25.2251 89.3522 24.5341 88.9124 23.6861C88.4413 22.7752 88.2057 21.7544 88.2214 20.7258H88.2371ZM96.1915 19.5479C96.1444 18.9669 95.8617 18.4329 95.4063 18.0638C94.4091 17.2865 93.0113 17.2786 92.0062 18.0403C91.5587 18.425 91.2603 18.959 91.1739 19.5401H96.1915V19.5479Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 11",
    d: "M103.346 15.3241H106.125V16.3135H106.165C106.966 15.4497 108.112 14.9707 109.29 15.0178C110.169 15.0021 111.025 15.2927 111.708 15.8423C112.407 16.4234 112.902 17.2086 113.13 18.0881L110.413 18.9832C110.161 18.143 109.361 17.5934 108.481 17.6641C107.861 17.6248 107.248 17.8525 106.816 18.3079C106.416 18.8026 106.212 19.4308 106.251 20.0669V26.0974H103.346V15.3398V15.3241Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 12",
    d: "M115.846 20.7258C115.822 19.6893 116.066 18.6606 116.537 17.7419C116.977 16.9017 117.644 16.2028 118.469 15.7317C119.34 15.2449 120.33 15.0014 121.327 15.025C122.308 15.0093 123.274 15.2606 124.115 15.7553C124.931 16.2421 125.599 16.9567 126.03 17.8047C126.502 18.7313 126.737 19.7678 126.721 20.8121V21.668H118.744C118.759 22.2962 119.042 22.893 119.513 23.3092C120.031 23.7489 120.699 23.9688 121.382 23.9374C121.9 23.9374 122.418 23.8196 122.882 23.584C123.447 23.2621 123.957 22.8459 124.381 22.359L126.188 24.2043C125.583 24.8796 124.853 25.4293 124.036 25.8141C123.204 26.2067 122.293 26.403 121.374 26.3951C120.361 26.4187 119.356 26.1753 118.469 25.6884C117.636 25.2251 116.961 24.5341 116.521 23.6861C116.05 22.7752 115.815 21.7544 115.83 20.7258H115.846ZM123.8 19.5479C123.753 18.9669 123.471 18.4329 123.015 18.0638C122.018 17.2865 120.62 17.2786 119.615 18.0403C119.168 18.425 118.869 18.959 118.783 19.5401H123.8V19.5479Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13",
    d: "M130.255 22.4233V15.3169H133.16V21.7558C133.019 22.6981 133.671 23.5776 134.613 23.7189C134.778 23.7424 134.943 23.7424 135.115 23.7189C135.634 23.7424 136.136 23.5461 136.505 23.1771C136.859 22.7845 137.047 22.2741 137.024 21.748V15.3091H139.929V26.0667H137.149V25.1166H137.11C136.78 25.5171 136.364 25.8312 135.885 26.0275C134.346 26.6714 132.579 26.4044 131.307 25.3286C130.577 24.5434 130.2 23.4912 130.263 22.4154L130.255 22.4233Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14",
    d: "M143.148 15.3241H145.708V16.2585H145.748C145.96 15.9051 146.266 15.6146 146.627 15.4183C146.988 15.222 147.404 15.1199 147.813 15.1199C148.661 15.1199 149.446 15.5754 149.862 16.3135H149.901C150.38 15.5518 151.228 15.0964 152.139 15.1199C152.87 15.0964 153.568 15.4026 154.047 15.9523C154.558 16.5569 154.817 17.3343 154.778 18.1195V26.0739H152.1V18.622C152.116 18.3629 152.029 18.1116 151.857 17.9153C151.668 17.7426 151.417 17.6562 151.166 17.6719C150.907 17.6641 150.663 17.7583 150.482 17.9467C150.31 18.1509 150.216 18.4179 150.231 18.6849V26.0739H147.695V18.622C147.711 18.3708 147.624 18.1195 147.459 17.9232C147.287 17.7504 147.043 17.6562 146.8 17.6641C146.533 17.6562 146.282 17.7504 146.093 17.9389C145.912 18.1431 145.81 18.41 145.826 18.677V26.066H143.148V15.3084V15.3241Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 15",
    d: "M50.0828 40.5452H47.2402V37.9461H50.0828V36.3599C50.0435 35.5118 50.389 34.6874 51.025 34.1141C51.7632 33.5331 52.6897 33.2347 53.632 33.2896H56.7572V35.8652H53.9775C53.7419 35.8495 53.5064 35.928 53.3258 36.0851C53.1687 36.2578 53.0902 36.4855 53.1059 36.7132V37.9304H57.4168V40.5295H53.1138V47.4945H50.0906V40.5295L50.0828 40.5452Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 16",
    d: "M60.6363 42.1235C60.6128 41.0949 60.8562 40.0819 61.3273 39.1711C61.7671 38.3309 62.4424 37.632 63.2668 37.1609C65.0572 36.2029 67.2008 36.2029 68.9912 37.1609C69.8157 37.632 70.491 38.3309 70.9307 39.1711C71.8494 41.0321 71.8494 43.215 70.9307 45.076C70.491 45.9162 69.8157 46.615 68.9912 47.0862C67.2008 48.0442 65.0572 48.0442 63.2668 47.0862C62.4424 46.615 61.7671 45.9162 61.3273 45.076C60.8562 44.1651 60.6206 43.1522 60.6363 42.1235ZM68.7163 42.1235C68.7635 41.3226 68.52 40.5374 68.0332 39.9013C67.5463 39.3517 66.8396 39.0611 66.1094 39.1004C65.387 39.0611 64.6881 39.3595 64.2091 39.9013C63.7223 40.5374 63.4789 41.3226 63.526 42.1235C63.4789 42.9245 63.7223 43.7097 64.2091 44.3457C65.2299 45.3901 66.9025 45.4136 67.9547 44.4007C67.9782 44.3771 67.9939 44.3614 68.0175 44.3379C68.5122 43.7097 68.7556 42.9245 68.7085 42.1235H68.7163Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 17",
    d: "M75.037 43.851V36.7446H77.9424V43.1835C77.801 44.1258 78.4528 45.0052 79.3951 45.1466C79.56 45.1701 79.7249 45.1701 79.8898 45.1466C80.408 45.1701 80.9106 44.9738 81.2796 44.6048C81.633 44.2122 81.8214 43.7018 81.7979 43.1757V36.7446H84.7032V47.5023H81.9235V46.5521H81.8842C81.5544 46.9526 81.1383 47.2667 80.6593 47.463C78.8297 48.476 76.5211 47.8164 75.5082 45.9789C75.147 45.3272 74.9899 44.5891 75.0449 43.851H75.037Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 18",
    d: "M88.7485 36.7446H91.6539V37.7575H91.6931C92.0936 37.3492 92.5726 37.0116 93.0987 36.776C93.6405 36.5483 94.2216 36.4305 94.8027 36.4384C95.4937 36.4384 96.169 36.6033 96.7736 36.9331C97.4018 37.2864 97.92 37.8125 98.2577 38.4564C98.6581 39.2416 98.8544 40.1211 98.823 41.0005V47.4944H95.9177V41.3853C95.9491 40.7885 95.7606 40.1918 95.3916 39.7206C95.0068 39.2887 94.4493 39.0532 93.8682 39.0924C93.2636 39.061 92.6825 39.273 92.2428 39.6892C91.8345 40.1368 91.6225 40.7336 91.6539 41.346V47.4944H88.7485V36.7367V36.7446Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 19",
    d: "M101.814 42.1235C101.798 41.1105 102.01 40.1133 102.442 39.2024C102.827 38.3701 103.439 37.6712 104.209 37.1765C104.978 36.6897 105.873 36.4306 106.784 36.4463C107.829 36.3835 108.857 36.7368 109.643 37.42H109.682V32.6929H112.587V47.5102H109.909V46.5757H109.87C109.046 47.4081 107.915 47.8557 106.745 47.8164C105.842 47.8321 104.963 47.5887 104.201 47.1097C103.439 46.6228 102.827 45.9318 102.442 45.1074C102.002 44.1729 101.79 43.16 101.814 42.1313V42.1235ZM109.69 42.8145V41.4168C109.69 41.0163 109.58 40.6237 109.368 40.2782C109.148 39.9248 108.834 39.6265 108.465 39.4301C108.072 39.2103 107.624 39.1003 107.177 39.1003C106.478 39.0689 105.811 39.3752 105.379 39.9248C104.491 41.2597 104.499 42.9951 105.387 44.3221C105.811 44.8639 106.462 45.178 107.153 45.1545C107.829 45.178 108.48 44.9346 108.975 44.4713C109.446 44.0473 109.705 43.4427 109.697 42.8145H109.69Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 20",
    d: "M116.514 44.6219C116.467 43.7267 116.844 42.863 117.543 42.2898C118.564 41.6066 119.741 41.1904 120.966 41.0727C121.555 41.0098 122.136 40.8528 122.678 40.6172C122.953 40.4994 123.126 40.2325 123.134 39.9341C123.134 39.6121 122.969 39.3216 122.686 39.1645C122.317 38.9604 121.893 38.8583 121.469 38.8819C120.919 38.874 120.377 39.0546 119.953 39.408C119.522 39.7613 119.231 40.2639 119.129 40.8057L116.428 40.1932C116.553 39.4786 116.875 38.8033 117.339 38.2458C117.825 37.6726 118.438 37.2172 119.129 36.9188C119.867 36.5968 120.66 36.4319 121.461 36.4398C122.67 36.377 123.856 36.7932 124.767 37.5941C125.607 38.395 126.055 39.5179 126.008 40.68V47.5037H123.408V46.3101H123.369C123.047 46.797 122.592 47.1739 122.058 47.4173C121.461 47.6843 120.817 47.8178 120.158 47.8099C119.506 47.8178 118.862 47.6843 118.273 47.4016C117.739 47.1503 117.291 46.7577 116.97 46.263C116.655 45.7762 116.491 45.203 116.498 44.6219H116.514ZM123.251 43.5069V42.2898H123.212C123.063 42.5096 122.851 42.6824 122.6 42.7766C122.168 42.9415 121.712 43.0593 121.257 43.1457C120.715 43.232 120.181 43.4048 119.694 43.6639C119.427 43.821 119.262 44.1115 119.27 44.4256C119.262 44.7083 119.404 44.9831 119.647 45.1323C119.977 45.3129 120.354 45.3993 120.731 45.3757C121.155 45.3757 121.579 45.2893 121.971 45.1166C122.333 44.9674 122.655 44.7318 122.906 44.4256C123.126 44.1665 123.244 43.8445 123.251 43.5069Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 21",
    d: "M135.799 39.3449V43.6715C135.775 43.962 135.861 44.2447 136.05 44.4646C136.285 44.653 136.592 44.7394 136.89 44.708H139.348V47.5113H136.631C135.642 47.5741 134.66 47.2757 133.875 46.6711C133.199 46.0586 132.846 45.1713 132.901 44.2683V39.3527H130.263V36.7536H132.901V34.0132H135.806V36.7536H140.031V39.3527H135.806L135.799 39.3449Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 22",
    d: "M154.228 44.8487V47.5107H143.651V44.8487H147.491V39.4071H143.856V36.7452H150.389V44.8409H154.228V44.8487ZM147.428 32.2065H150.412V35.0648H147.428V32.2065Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 23",
    d: "M157.251 42.1235C157.236 41.0949 157.471 40.0819 157.942 39.1711C158.382 38.3309 159.057 37.632 159.882 37.1609C161.672 36.2029 163.816 36.2029 165.606 37.1609C166.431 37.632 167.106 38.3309 167.546 39.1711C168.464 41.0321 168.464 43.215 167.546 45.076C167.106 45.9162 166.431 46.615 165.606 47.0862C163.816 48.0442 161.672 48.0442 159.882 47.0862C159.057 46.615 158.382 45.9162 157.942 45.076C157.471 44.1651 157.236 43.1522 157.251 42.1235ZM165.331 42.1235C165.378 41.3226 165.135 40.5374 164.648 39.9013C164.161 39.3517 163.455 39.0611 162.732 39.1004C162.01 39.0611 161.311 39.3595 160.832 39.9013C160.345 40.5374 160.102 41.3226 160.149 42.1235C160.102 42.9245 160.345 43.7097 160.832 44.3457C161.853 45.3901 163.525 45.4136 164.577 44.4007C164.601 44.3771 164.617 44.3614 164.64 44.3379C165.127 43.7097 165.378 42.9245 165.331 42.1235Z",
    fill: "#88898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 24",
    d: "M171.566 36.7446H174.471V37.7575H174.511C174.911 37.3492 175.39 37.0116 175.908 36.776C176.45 36.5483 177.031 36.4305 177.612 36.4384C178.303 36.4384 178.979 36.6033 179.583 36.9331C180.211 37.2864 180.73 37.8125 181.067 38.4564C181.468 39.2416 181.664 40.1211 181.633 41.0005V47.4944H178.727V41.3853C178.759 40.7885 178.57 40.1918 178.201 39.7206C177.816 39.2887 177.259 39.0532 176.678 39.0924C176.073 39.061 175.492 39.273 175.052 39.6892C174.644 40.1368 174.432 40.7336 174.463 41.346V47.4944H171.558V36.7367L171.566 36.7446Z",
    fill: "#88898E"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Hero section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "looper1",
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_53",
    opacity: 0.757143,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-206.134 -391.033C-304.098 -506.591 -481.809 -402.786 -454.914 -630.65C-428.02 -858.514 -147.185 -1008.37 42.4829 -908.901C232.15 -809.435 305.181 -756.516 373.591 -788.708C442.002 -820.9 611.71 -866.95 672.322 -771.207C732.934 -675.464 739.994 -604.377 606.226 -524.657C472.458 -444.936 377.776 -439.692 309.388 -442.814C241 -445.937 150.043 -191.827 6.31212 -203.126C-137.419 -214.424 -108.17 -275.475 -206.134 -391.033Z",
    stroke: "url(#paint0_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_52",
    opacity: 0.742857,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-201.191 -385.886C-301.106 -499.661 -476.841 -392.864 -453.978 -621.017C-431.115 -849.169 -153.152 -1003.76 38.1066 -907.653C229.365 -811.542 303.265 -759.927 371.052 -793.277C438.838 -826.627 607.594 -875.575 669.839 -780.954C732.085 -686.333 740.39 -615.423 608.137 -533.452C475.883 -451.48 381.373 -444.602 312.988 -446.54C244.602 -448.478 158.192 -192.992 14.3826 -201.797C-129.426 -210.601 -101.276 -272.111 -201.191 -385.886Z",
    stroke: "url(#paint1_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_51",
    opacity: 0.728571,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-196.157 -380.827C-297.99 -492.786 -471.7 -383.034 -452.87 -611.405C-434.04 -839.775 -159.029 -999.054 33.7611 -906.325C226.551 -813.596 301.297 -763.298 368.441 -797.794C435.584 -832.29 603.338 -884.117 667.196 -790.646C731.054 -697.175 740.6 -626.464 609.9 -542.27C479.199 -458.075 384.888 -449.569 316.526 -450.323C248.163 -451.078 166.32 -194.297 22.4759 -200.608C-121.368 -206.92 -94.3233 -268.868 -196.157 -380.827Z",
    stroke: "url(#paint2_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_50",
    opacity: 0.714286,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-191.04 -375.869C-294.759 -485.979 -466.394 -373.311 -451.598 -601.827C-436.802 -830.344 -164.821 -994.252 29.4405 -904.928C223.702 -815.605 299.271 -766.639 365.752 -802.268C432.233 -837.898 598.936 -892.584 664.386 -800.29C729.835 -707.996 740.618 -637.506 611.507 -551.118C482.396 -464.731 388.313 -454.601 319.994 -454.173C251.675 -453.744 174.418 -195.75 30.582 -199.57C-113.254 -203.39 -87.3215 -265.758 -191.04 -375.869Z",
    stroke: "url(#paint3_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_49",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-185.843 -370.998C-291.414 -479.229 -460.925 -363.682 -450.162 -592.274C-439.399 -820.866 -170.526 -989.346 25.1467 -903.451C220.82 -817.556 297.189 -769.935 362.988 -806.685C428.787 -843.436 594.39 -900.961 661.41 -809.871C728.43 -718.781 740.443 -648.533 612.959 -559.982C485.475 -471.431 391.648 -459.683 323.392 -458.074C255.137 -456.465 182.483 -197.339 38.6989 -198.67C-105.085 -200 -80.272 -262.767 -185.843 -370.998Z",
    stroke: "url(#paint4_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_48",
    opacity: 0.685714,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-180.566 -366.225C-287.955 -472.545 -455.293 -354.16 -448.562 -582.756C-441.83 -811.353 -176.143 -984.346 20.8813 -901.901C217.905 -819.457 295.05 -773.194 360.148 -811.052C425.247 -848.911 589.702 -909.252 658.27 -819.394C726.838 -729.535 740.078 -659.55 614.256 -568.866C488.434 -478.182 394.891 -464.821 326.72 -462.034C258.549 -459.246 190.514 -199.071 46.8242 -197.915C-96.8657 -196.759 -73.1771 -259.905 -180.566 -366.225Z",
    stroke: "url(#paint5_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_47",
    opacity: 0.671429,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-175.208 -361.551C-284.381 -465.93 -449.5 -344.748 -446.796 -573.277C-444.093 -801.806 -181.666 -979.253 16.6485 -900.28C214.963 -821.307 292.859 -776.415 357.238 -815.368C421.617 -854.322 584.876 -917.457 654.97 -828.856C725.063 -740.254 739.524 -670.555 615.4 -577.768C491.277 -484.982 398.045 -470.015 329.978 -466.052C261.912 -462.088 198.511 -200.945 54.9585 -197.307C-88.594 -193.668 -66.0359 -257.173 -175.208 -361.551Z",
    stroke: "url(#paint6_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_46",
    opacity: 0.657143,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-169.775 -356.97C-280.696 -459.377 -443.549 -335.439 -444.869 -563.83C-446.19 -792.221 -187.098 -974.061 12.446 -898.579C211.99 -823.098 290.612 -779.588 354.254 -819.623C417.895 -859.657 579.912 -925.564 651.507 -838.245C723.103 -750.927 738.779 -681.533 616.389 -586.677C493.998 -491.82 401.105 -475.254 333.164 -470.117C265.222 -464.98 206.468 -202.953 63.0957 -196.836C-80.2766 -190.719 -58.8542 -254.562 -169.775 -356.97Z",
    stroke: "url(#paint7_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_45",
    opacity: 0.642857,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-164.269 -352.493C-276.903 -452.9 -437.444 -326.247 -442.782 -554.43C-448.121 -782.613 -192.437 -968.783 8.27438 -896.811C208.986 -824.84 288.311 -782.725 351.197 -823.827C414.083 -864.929 574.809 -933.582 647.884 -847.572C720.958 -761.562 737.843 -692.496 617.22 -595.601C496.598 -498.706 404.071 -480.548 336.274 -474.241C268.477 -467.934 214.382 -205.104 71.2325 -196.514C-71.9169 -187.925 -51.6352 -252.086 -164.269 -352.493Z",
    stroke: "url(#paint8_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_44",
    opacity: 0.628571,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-158.689 -348.113C-273 -446.491 -431.184 -317.168 -440.534 -545.071C-449.883 -772.975 -197.68 -963.411 4.13723 -894.968C205.955 -826.525 285.958 -785.815 348.07 -827.97C410.182 -870.126 569.572 -941.501 644.102 -856.824C718.632 -772.148 736.718 -703.43 617.897 -604.529C499.076 -505.629 406.943 -485.886 339.311 -478.413C271.68 -470.94 222.253 -207.39 79.3687 -196.333C-63.5151 -185.276 -44.3788 -249.735 -158.689 -348.113Z",
    stroke: "url(#paint9_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_43",
    opacity: 0.614286,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-153.035 -343.836C-268.986 -440.157 -424.769 -308.206 -438.122 -535.76C-451.475 -763.314 -202.823 -957.952 0.0387009 -893.054C202.9 -828.156 283.556 -788.862 344.877 -832.056C406.198 -875.25 564.205 -949.321 640.166 -866.003C716.127 -782.685 735.408 -714.336 618.422 -613.464C501.436 -512.591 409.723 -491.272 342.277 -482.636C274.83 -474 230.08 -209.813 87.5045 -196.296C-55.0712 -182.778 -37.0844 -247.515 -153.035 -343.836Z",
    stroke: "url(#paint10_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_42",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-147.317 -339.664C-264.872 -433.9 -418.209 -299.367 -435.556 -526.5C-452.903 -753.634 -207.872 -952.409 -4.02877 -891.071C199.815 -829.733 281.098 -791.866 341.611 -836.084C402.124 -880.302 558.702 -957.043 636.069 -875.107C713.436 -793.17 733.905 -725.212 618.786 -622.401C503.667 -519.591 412.402 -496.704 345.161 -486.91C277.92 -477.115 237.854 -212.374 95.629 -196.404C-46.5963 -180.433 -29.7628 -245.427 -147.317 -339.664Z",
    stroke: "url(#paint11_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_41",
    opacity: 0.585714,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-141.525 -335.593C-260.645 -427.719 -411.495 -290.648 -432.825 -517.291C-454.155 -743.935 -212.814 -946.779 -8.05109 -889.016C196.712 -831.252 278.598 -794.823 338.285 -840.05C397.972 -885.277 553.078 -964.66 631.826 -884.129C710.574 -803.599 732.222 -736.052 619.003 -631.337C505.784 -526.622 414.993 -502.178 347.977 -491.229C280.961 -480.28 245.585 -215.069 103.752 -196.653C-38.0806 -178.237 -22.4041 -243.468 -141.525 -335.593Z",
    stroke: "url(#paint12_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_40",
    opacity: 0.571429,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-135.674 -331.629C-256.322 -421.618 -404.643 -282.054 -429.944 -508.138C-455.245 -734.222 -217.662 -941.067 -12.0419 -886.892C193.578 -832.717 276.041 -797.733 334.886 -843.954C393.731 -890.175 547.319 -972.172 627.422 -893.071C707.526 -813.97 730.346 -746.853 619.057 -640.27C507.769 -533.686 417.479 -507.693 350.708 -495.595C283.937 -483.497 253.255 -217.898 111.857 -197.046C-29.5415 -176.194 -15.0249 -241.64 -135.674 -331.629Z",
    stroke: "url(#paint13_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_39",
    opacity: 0.557143,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-129.755 -327.772C-251.894 -415.599 -397.644 -273.59 -426.903 -499.045C-456.163 -724.499 -222.403 -935.275 -15.9889 -884.701C190.425 -834.127 273.44 -800.598 331.426 -847.797C389.412 -894.996 541.438 -979.578 622.871 -901.929C704.305 -824.28 728.288 -757.615 618.961 -649.198C509.634 -540.781 419.871 -513.249 353.365 -500.007C286.858 -486.765 260.873 -220.861 119.951 -197.582C-20.9705 -174.304 -7.61669 -239.945 -129.755 -327.772Z",
    stroke: "url(#paint14_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_38",
    opacity: 0.542857,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-123.776 -324.021C-247.366 -409.661 -390.506 -265.254 -423.709 -490.01C-456.912 -714.766 -227.041 -929.403 -19.8959 -882.44C187.249 -835.478 270.79 -803.413 327.901 -851.574C385.012 -899.735 535.433 -986.873 618.17 -910.698C700.907 -834.524 726.045 -768.33 618.709 -658.116C511.373 -547.902 422.164 -518.841 355.941 -504.461C289.719 -490.08 268.432 -223.954 128.029 -198.259C-12.3753 -172.564 -0.186613 -238.381 -123.776 -324.021Z",
    stroke: "url(#paint15_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_37",
    opacity: 0.528571,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-117.736 -320.377C-242.738 -403.806 -383.227 -257.048 -420.359 -481.037C-457.491 -705.025 -231.571 -923.452 -23.7583 -880.111C184.054 -836.771 268.095 -806.178 324.315 -855.285C380.536 -904.392 529.309 -994.056 613.323 -919.378C697.336 -844.699 723.619 -778.997 618.305 -667.022C512.99 -555.047 424.36 -524.469 358.441 -508.956C292.522 -493.442 275.934 -227.177 136.089 -199.077C-3.7554 -170.976 7.26614 -236.947 -117.736 -320.377Z",
    stroke: "url(#paint16_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_36",
    opacity: 0.514286,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-111.64 -316.847C-238.014 -398.043 -375.816 -248.983 -416.859 -472.135C-457.903 -695.287 -235.997 -917.431 -27.5797 -877.722C180.837 -838.012 265.353 -808.899 320.666 -858.936C375.98 -908.972 523.063 -1001.13 608.327 -927.97C693.59 -854.808 721.009 -789.618 617.744 -675.919C514.479 -562.22 426.454 -530.136 360.858 -513.496C295.262 -496.856 283.37 -230.535 144.126 -200.041C4.88202 -169.547 14.7348 -235.651 -111.64 -316.847Z",
    stroke: "url(#paint17_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_35",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-105.487 -313.42C-233.194 -392.359 -368.27 -241.046 -413.208 -463.294C-458.145 -685.542 -240.314 -911.33 -31.3556 -875.259C177.603 -839.188 262.566 -811.562 316.958 -862.512C371.35 -913.461 516.701 -1008.08 603.187 -936.46C689.673 -864.837 718.218 -800.178 617.03 -684.792C515.843 -569.406 428.449 -535.828 363.195 -518.068C297.942 -500.309 290.742 -234.015 152.14 -201.139C13.5375 -168.263 22.2201 -234.48 -105.487 -313.42Z",
    stroke: "url(#paint18_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_34",
    opacity: 0.485714,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-99.2807 -310.109C-228.28 -386.77 -360.594 -233.254 -409.406 -454.529C-458.219 -675.805 -244.521 -905.162 -35.0856 -872.736C174.35 -840.311 259.736 -814.179 313.191 -866.024C366.646 -917.87 510.224 -1014.92 597.904 -944.858C685.585 -874.794 715.245 -810.685 616.163 -693.651C517.081 -576.616 430.343 -541.556 365.451 -522.683C300.559 -503.811 298.048 -237.626 160.128 -202.382C22.2074 -167.138 29.7189 -233.447 -99.2807 -310.109Z",
    stroke: "url(#paint19_linear_27_1327)",
    strokeWidth: 1.21751
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path 3_33",
    opacity: 0.471429,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-93.0207 -306.905C-223.272 -381.268 -352.787 -225.598 -405.455 -445.834C-458.122 -666.07 -248.617 -898.92 -38.7669 -870.146C171.083 -841.373 256.865 -816.74 309.368 -869.464C361.871 -922.189 503.636 -1021.64 592.483 -953.153C681.331 -884.667 712.096 -821.128 615.146 -702.483C518.196 -583.838 432.139 -547.309 367.627 -527.331C303.115 -507.353 305.287 -241.359 168.089 -203.761C30.8909 -166.163 37.2309 -232.543 -93.0207 -306.905Z",
    stroke: "url(#paint20_linear_27_1327)",
    strokeWidth: 1.21751
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_1327",
    x: -657.932,
    y: 15.8481,
    width: 904,
    height: 904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 177,
    result: "effect1_foregroundBlur_27_1327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_1327",
    x1: -562.777,
    y1: -665.92,
    x2: -41.7801,
    y2: -7.14159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_1327",
    x1: -562.371,
    y1: -654.395,
    x2: -30.2214,
    y2: -5.13297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_1327",
    x1: -561.76,
    y1: -642.883,
    x2: -18.6308,
    y2: -3.32637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27_1327",
    x1: -560.951,
    y1: -631.398,
    x2: -7.01941,
    y2: -1.73237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_1327",
    x1: -559.945,
    y1: -619.932,
    x2: 4.60963,
    y2: -0.338099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27_1327",
    x1: -558.742,
    y1: -608.494,
    x2: 16.2529,
    y2: 0.847868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27_1327",
    x1: -557.34,
    y1: -597.09,
    x2: 27.9098,
    y2: 1.82513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_27_1327",
    x1: -555.742,
    y1: -585.713,
    x2: 39.5732,
    y2: 2.60277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_27_1327",
    x1: -553.951,
    y1: -574.379,
    x2: 51.2386,
    y2: 3.16873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_27_1327",
    x1: -551.965,
    y1: -563.082,
    x2: 62.9048,
    y2: 3.53221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_27_1327",
    x1: -549.781,
    y1: -551.83,
    x2: 74.5708,
    y2: 3.68868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_27_1327",
    x1: -547.41,
    y1: -540.627,
    x2: 86.2246,
    y2: 3.63814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_27_1327",
    x1: -544.84,
    y1: -529.473,
    x2: 97.8751,
    y2: 3.3841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_27_1327",
    x1: -542.086,
    y1: -518.373,
    x2: 109.504,
    y2: 2.92425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_27_1327",
    x1: -539.139,
    y1: -507.332,
    x2: 121.119,
    y2: 2.25848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_27_1327",
    x1: -536.004,
    y1: -496.35,
    x2: 132.711,
    y2: 1.39046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_27_1327",
    x1: -532.68,
    y1: -485.43,
    x2: 144.28,
    y2: 0.319941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_27_1327",
    x1: -529.172,
    y1: -474.582,
    x2: 155.818,
    y2: -0.958808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_27_1327",
    x1: -525.479,
    y1: -463.797,
    x2: 167.325,
    y2: -2.43243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_27_1327",
    x1: -521.602,
    y1: -453.09,
    x2: 178.796,
    y2: -4.11266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_27_1327",
    x1: -517.541,
    y1: -442.455,
    x2: 190.23,
    y2: -5.98945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A7E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_1327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 5129,
    fill: "white",
    transform: "translate(-812 -949)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.882cf6b61fc469df8a82381e4cad5ea0.svg";
export { ForwardRef as ReactComponent };